var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadCrumb',_vm._b({staticClass:"mb-5"},'BreadCrumb',_vm.breadCrumb,false)),_c('NewRegisterSchool',{attrs:{"placeholder":_vm.placeholder,"title":_vm.title,"school":_vm.school,"isNew":_vm.isNew},on:{"create":_vm.create}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }